export const DEFAULT_TOKEN_EXPIRES_IN_SECONDS = 86400;

export function computeExpiresIn(tokenExpirationInstant?: number | null): number {
  if (typeof tokenExpirationInstant !== "number") return DEFAULT_TOKEN_EXPIRES_IN_SECONDS;
  return Math.floor((tokenExpirationInstant - Date.now()) / 1000);
}

export function postAuthTokenToNative(params: {
  token: string;
  refreshToken?: string;
  tokenExpirationInstant?: number | null;
  refreshUrl?: string;
}): void {
  window.ReactNativeWebView?.postMessage(
    JSON.stringify({
      access_token: params.token,
      expires_in: computeExpiresIn(params.tokenExpirationInstant),
      refresh_token: params.refreshToken,
      refresh_url: params.refreshUrl,
      status: 200,
    }),
  );
}
